<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import CustomList from "../../../../compositions/CustomList.vue";
import ModalDialog from "../../../../compositions/ModalDialog.vue";
import SearchBox from "../../../../compositions/SearchBox.vue";
import OrderMedicineComponent from '../../../Common/OrderMedicineComponent.vue';
import config from "../../../../config.js";
import { errorAlert } from "../../../../plugins/alert";
import { getFieldValue } from "../../../../plugins/utility";
import qs from 'qs';
import axios from '../../../../plugins/axios.ts';
import { useOrderStore } from '../../../../stores/order';
import HelpAction from '../../../../compositions/HelpAction.vue';

const order = useOrderStore();

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    pharmacyWholesalers:{
      type:Array,
      required:true,
    },
    identityId: {
      typ:Number,
      default:() => {
        return 0;
      }
    },
    isVisible:{
        type:Boolean,
        default: () => {
            return false;
        }
    }
})

const { isVisible,identityId } = toRefs(props);
const listHeight = ref(0);
const headerRef = ref();
const listOrderTodayPackRef = ref();
const searchWord = ref('');
const changeListHeight = () => {
  if (typeof headerRef.value !== 'undefined') {
    listHeight.value = window.innerHeight - document.getElementById('header').clientHeight - document.getElementById('footer').clientHeight - document.getElementById('order_header').clientHeight - headerRef.value.clientHeight - 5;
    if (listHeight.value < 200) {
      listHeight.value = 200;
    }
  }
}
const handler = (name:string,value:Object,eof:Boolean=false) => {
  if (name == 'item') {
  }
}
const orderFields = ref([
  {field_name: '採用品', field_key: 'product_name', width: '35%', align: 'text-left', sorted:true},
  {field_name: '発送先', field_key: 'pack_to_pharmacy', width: '15%', align: 'text-left', sorted:true,is_join:true},
  {field_name: '包装単位', field_key: 'package_label', width: '35%', align: 'text-left', sorted:false,is_join:true},
  {field_name: '発送数', field_key: 'number', width: '7%', align: 'text-center',is_join:true},
  {field_name: '', field_key: 'action_pack_reverse', width: '15%', align: 'text-center'},
]);
const orderOptionFields = reactive({
  'search_word' : searchWord.value,
  'page_size' : 30,
  'is_today_pack' : 1
});
const listSearch = (force = false,delay=0) => {
  orderOptionFields.search_word = searchWord.value;
  if (force == false) {
    listOrderTodayPackRef.value.resetItem(delay);
  } else {
    listOrderTodayPackRef.value.resetForceItem(delay);
  }
}
const onSearchWordChange = (value) => {
  searchWord.value = value;
}
const onSearchWordEnter = (value) => {
  searchWord.value = value;
  listSearch();
}

const editSettingComplete = () => {
  listSearch(false,config.LIST_DELAY);
}
const editOrderPackWaitCancel = (action,count) => {
  listSearch();
  order.order_today_pack_count--;
  order.order_pack_count++;
}

watch(isVisible,(newValue, oldValue) => {
  if (newValue) {
    listSearch();
  }
})
watch(identityId,(newValue, oldValue) => {
  listSearch(true);
})

const domComplete = () => {
  order.order_today_pack_count = listOrderTodayPackRef.value.getItemAllCount();
}
onBeforeUnmount(() => {
  window.removeEventListener('resize', changeListHeight);
})
onMounted(() => {
  setTimeout(changeListHeight,100);
  listSearch();
  window.addEventListener('resize', changeListHeight);
});
</script>

<style scoped>
</style>
<template>
<div v-show="isVisible" class="relative">
  <div class="absolute top-2 left-2">
    <help-action
      help-key="order_today_pack_list_help"
    ></help-action>
  </div>
  <div ref="headerRef" class="w-full flex items-center justify-end p-2 bg-gray-100 rounded">
    <div class="mb-2 mt-1">
    <search-box
        :search-word="searchWord"
        :on-change="onSearchWordChange"
        :on-enter="onSearchWordEnter"
        place-holder="採用品名を入力"
    ></search-box>
    </div>
  </div>
  <div class="w-full">
    <custom-list
      ref="listOrderTodayPackRef"
      :table-fields="orderFields"
      :option-fields="orderOptionFields"
      :api-url="apis.pharmacy_stock_pack_list"
      :height="listHeight + 'px'"
      :handler="handler"
      :is-cell-join="true"
      :dom-complete="domComplete"
    >
    <template v-slot:item="slotProps">
      <order-medicine-component
        :apis="apis"
        type="is_today_pack"
        :pharmacy-wholesalers="pharmacyWholesalers"
        :identity-id="slotProps.item.id"
        :item="slotProps.item"
        :fields="orderFields"
        join-field-key="pharmacy_stocks"
        :edit-order-pack-wait-cancel="editOrderPackWaitCancel"
        :edit-setting-complete="editSettingComplete"
      ></order-medicine-component>
    </template>
    </custom-list>
  </div>

</div>
</template>

